const passwordStrength = {
  passwordStrength: {
    minimumCharacters: "La contraseña debe tener más de ocho caractéres.",
    caps: "Debes usar una combinación de mayúsculas y minúsculas.",
    specialCharacters: "Debes incluir números y caractéres especiales.",
  },
};

export default passwordStrength;
